<template>
    <section class="section">
        <div class="spring spring--narrow">
            <div class="js-component-component component__component" data-component="world-traveller-bundle">
                <!-- new implementation -->
                <div class="bundle">
                    <div v-if="this.$router.currentRoute.fullPath !== '/?info=cartela'">
                        <p class="tag tag--green" v-if="$root.selectedCountry.prepaid === 1 && ['AT', 'BG', 'BE', 'CZ', 'CY', 'HR', 'DK', 'EE', 'FI', 'FR', 'DE', 'GI', 'GR', 'GP', 'GY', 'RE', 'IE', 'IS', 'IT', 'LV', 'LI', 'LU', 'MT', 'GB', 'NO', 'NL', 'PL', 'PT', 'SK', 'SI', 'ES', 'SE', 'HU'].indexOf(this.$root.selectedCountry.countryCodeISO) === -1">
                            <span class="visually-hidden">Recomandat</span>
                            <span class="tag__label">Recomandat</span>
                        </p>
                    </div>
                    <h3 class="visually-hidden">Oferta</h3>
                    <div class="bundle__summary">
                        <div class="bundle-data bundle-data--small bundle-data--red bundle-data__value--small">
                            <div class="bundle-data__value bundle-data__value">
                                <span class="visually-hidden">Include</span>
                                <div class="bundle-data__heading" tabindex="0">
                                    <span v-if="['EG', 'AL', 'JO', 'UA', 'BA', 'AR', 'AU', 'CA', 'CH', 'HK', 'IN', 'ID', 'IL', 'JP', 'JE', 'KE', 'KV', 'MK', 'MY', 'MD', 'QA', 'RS', 'SG', 'US', 'TH', 'TR', 'VN'].indexOf($root.selectedCountry.countryCodeISO) !== -1" class="bundle-data__amount">100</span>
                                    <span v-else class="bundle-data__amount">5.170</span>
                                    <span class="bundle-data__unit">MB</span>
                                </div>
                                date roaming
                                <span v-if="['EG', 'AL', 'JO', 'UA', 'BA', 'AR', 'AU', 'CA', 'CH', 'HK', 'IN', 'ID', 'IL', 'JP', 'JE', 'KE', 'KV', 'MK', 'MY', 'MD', 'QA', 'RS', 'SG', 'US', 'TH', 'TR', 'VN'].indexOf($root.selectedCountry.countryCodeISO) !== -1">non-SEE</span>
                                <span v-else><br />în SEE</span>
                            </div>
                            <div class="bundle-data__value bundle-data__value bundle-data--red bundle-data__value--small bundle-data__value--l-border">
                                <div class="bundle-data__heading">
                                    <span v-if="['EG', 'AL', 'JO', 'UA', 'BA', 'AR', 'AU', 'CA', 'CH', 'HK', 'IN', 'ID', 'IL', 'JP', 'JE', 'KE', 'KV', 'MK', 'MY', 'MD', 'QA', 'RS', 'SG', 'US', 'TH', 'TR', 'VN'].indexOf($root.selectedCountry.countryCodeISO) !== -1" class="bundle-data__amount">10</span>
                                    <span v-else class="bundle-data__amount">100</span>
                                </div>
                                <span v-if="['EG', 'AL', 'JO', 'UA', 'BA', 'AR', 'AU', 'CA', 'CH', 'HK', 'IN', 'ID', 'IL', 'JP', 'JE', 'KE', 'KV', 'MK', 'MY', 'MD', 'QA', 'RS', 'SG', 'US', 'TH', 'TR', 'VN'].indexOf($root.selectedCountry.countryCodeISO) !== -1">minute/SMS-uri în non-SEE</span>
                                <span v-else>minute/SMS-uri na&#355;ionale <br />&#351;i &icirc;n roaming SEE</span>
                            </div>
                        </div>
                        <div class="bundle-title">
                            <div class="bundle-title__row">
                                <h4 class="heading heading--4 heading--light heading--leading heading--trailing">
                                    Oferta
                                    <strong>4</strong>
                                </h4>
                            </div>
                        </div>
                        <p class="bundle-price">
                            <span class="visually-hidden">Costul pachetului</span>
                            <strong class="bundle-price__cost">4€ <span class="heading--4 heading--light heading--leading heading--trailing">credit</span></strong>
                            <span class="offer-validity--text">7 zile de valabilitate</span>
                        </p>
                    </div>
                    <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                        <div class="js-accordion-content show-more__content" v-show="toggle_prepaid_extins_2">
                            <p class="visually-hidden">Include</p>
                            <p class="text-center">
                                <span class="tooltip__info-text">Beneficii în Spațiul Economic European (SEE)</span>
                                <span class="tooltip-img" data-tippy-content="Țările SEE: Austria, Azore, Belgia, Bulgaria, Cehia, Cipru, Croația, Danemarca, Estonia, Finlanda, Franța, Germania, Grecia, Guadelupa, Guyana Franceză, Insula Sfântul Martin, Insulele Åland, Insulele Canare, Insulele Reunion, Irlanda, Islanda, Italia, Letonia, Liechtenstein, Lituania, Luxemburg, Madeira, Malta, Martinica, Mayotte, Norvegia, Olanda, Polonia, Portugalia, Slovacia, Slovenia, Spania, Suedia, Ungaria"></span>
                            </p>
                            <ul class="list list--reset bundle__inclusions">
                                <li class="bundle__inclusion bundle__small-padding flush--top">
                                    <img src="https://static.vodafone.ro/roaming/images/v546124.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>117 GB</strong> internet național, din care
                                    <strong>5 GB</strong>
                                    date în roaming SEE
                                </li>
                                <li class="bundle__inclusion bundle__small-padding">
                                    <img src="https://static.vodafone.ro/roaming/images/v546117.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>100</strong> minute/SMS-uri na&#355;ionale &#351;i &icirc;n roaming SEE
                                </li>
                                <li class="bundle__inclusion bundle__small-padding">
                                    <img src="https://static.vodafone.ro/roaming/images/v546117.png" alt class="icon bundle__inclusion-bullet" />
                                    <strong>Nelimitat</strong>
                                    minute și SMS-uri în re&#355;ea
                                </li>
                            </ul>

                            <div>
                                <p class="text-center">
                                    <span class="tooltip__info-text">
                                        Beneficii în afara Spațiului Economic European
                                        <br />(non-SEE)
                                    </span>
                                    <span class="tooltip-img" data-tippy-content="Țările din afara Spațiului Economic European (SEE) pentru Oferta 4 cu roaming: Turcia, Albania, Macedonia, Muntenegru, Serbia, Bosnia si Hertzegovina"></span>
                                </p>
                                <ul class="list list--reset bundle__inclusions">
                                    <li class="bundle__inclusion bundle__small-padding flush--top">
                                        <img src="https://static.vodafone.ro/roaming/images/v546124.png" alt class="icon bundle__inclusion-bullet" />
                                        <strong>100MB</strong> date roaming
                                    </li>
                                    <li class="bundle__inclusion bundle__small-padding">
                                        <img src="https://static.vodafone.ro/roaming/images/v546117.png" alt class="icon bundle__inclusion-bullet" />
                                        <strong>10</strong> Minute / SMS-uri în roaming
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <button-more @click.native="toggle_prepaid_extins_2 = !toggle_prepaid_extins_2" :more="toggle_prepaid_extins_2" prefix="Arată mai"></button-more>
                    </div>
                    <div class="bundle__select bundle__select--first">
                        <a :href="hrefActivate" class="button button--secondary button--full-width"> Activează opțiunea </a>
                    </div>
                </div>
                <!-- new implementation end -->
            </div>
        </div>
    </section>
</template>

<script>
import ButtonMore from './ButtonMore.vue';
export default {
    name: 'OfferPrepaid_4',
    components: {
        ButtonMore,
    },
    data() {
        return {
            toggle_offer: false,
            toggle_prepaid_extins_2: false,
            recommended_offer: false,
            hrefActivate: this.$root.hrefActivate,
        };
    },
    methods: {
        expand() {
            this.toggle_offer = true;
        },
        recommended_check() {
            if (this.$root.selectedCountry !== null) {
                if (this.$root.selectedCountry.prepaid === 1) {
                    if (['AT', 'BG', 'BE', 'CZ', 'CY', 'HR', 'DK', 'EE', 'FI', 'FR', 'DE', 'GI', 'GR', 'GP', 'GY', 'RE', 'IE', 'IS', 'IT', 'LV', 'LI', 'LU', 'MT', 'GB', 'NO', 'NL', 'PL', 'PT', 'SK', 'SI', 'ES', 'SE', 'HU'].indexOf(this.$root.selectedCountry.countryCodeISO) === -1) {
                        this.recommended_offer = true;
                        this.toggle_prepaid_extins_2 = true;
                    }
                } else {
                    this.recommended_offer = false;
                    this.toggle_prepaid_extins_2 = false;
                }
            }
        },
    },
    mounted() {
        this.$root.$on('prepare-for-pdf', this.expand);
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
                // console.log(this.windowWidth);
                if (this.windowWidth <= 768) {
                    this.toggle_prepaid_extins_2 = false;
                } else {
                    this.toggle_prepaid_extins_2 = true;
                }
            });
            this.recommended_check();
        });
    },
    beforeDestroy() {
        this.$root.$off('prepare-for-pdf', this.expand);
    },
};
</script>
